module.exports = __webpack_public_path__ + "img/img19.922af0ef.png";